import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash} from '@fortawesome/free-solid-svg-icons';


const Items = ({rows,setRows, handleAddRow, handleRemoveRow}) => {

    const handleInputChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        setRows(newRows);
    };

    const renderRows = () => {
        if(rows.length === 0){
            return <p style={{color: 'red', marginBottom: 20}}>Zatím jste nepřidal žádnou položku k fakturaci</p>
        }
        return rows.map((row, index) => (
            <Row key={index} style={{ background: '#eee', margin: 5, borderRadius: 8 , padding: 5}}>
                <Col sm={2}>
                    <input
                        className='prettyInput'
                        type='number'
                        value={row.quantity}
                        onChange={(e) => handleInputChange(index, 'quantity', parseInt(e.target.value))}
                    />
                </Col>
                <Col sm={7}>
                    <input
                        className='prettyInput'
                        value={row.item}
                        placeholder='...'
                        onChange={(e) => handleInputChange(index, 'item', e.target.value)}
                    />
                </Col>
                <Col sm={2}>
                    <input
                        className='prettyInput'
                        type='number'
                        value={row.price}
                        onChange={(e) => handleInputChange(index, 'price', parseFloat(e.target.value))}
                    />
                </Col>
                <Col sm={1}>
                    {!row.schedule && <FontAwesomeIcon icon={faTrash} onClick={() => handleRemoveRow(index)} color={'grey'}/> }
                </Col>
            </Row>
        ));
    };

    return (
        <div>
            <Row>
                <h3 style={{color: 'rgb(5, 44, 101)'}}>Položky na faktuře</h3>
            </Row>
            <Row style={{  borderRadius: 8 }}>
                <Col sm={2}><strong>Množství</strong></Col>
                <Col sm={7}><strong>Položka</strong></Col>
                <Col sm={2}><strong>Cena</strong></Col>
                <Col sm={1}></Col>
            </Row>
            {renderRows()}
            <Row style={{ margin: 0, borderRadius: 8}}>
                <Col sm={12} >
                    <button onClick={handleAddRow} style={{background: '#940042', border: 'none', color: 'white', borderRadius: 10, padding: 3}}> <FontAwesomeIcon icon={faPlus} /> Přidat položku</button>
                </Col>
            </Row>
        </div>
    );
};

export default Items;
